module.exports = __webpack_public_path__ + "img/pirates-logo.64d1b132.svg";